import React, { useState, useContext, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Button, Row, Col, Container, /*Form,*/ Card, Accordion, AccordionContext, useAccordionToggle } from 'react-bootstrap'
import { graphql } from 'gatsby'

import { Layout, ActNow, ButtonAnalytics } from '../components/common'
import { MetaData } from '../components/common/meta'

import CheckmarkImage from '../images/home/checkmark.svg'
import { request } from 'graphql-request'
import { graphCMSUrl } from '../utils/siteConfig'

/**
* Main index page (home page)
*
* Loads all posts from Ghost and uses pagination to navigate through them.
* The number of posts that should appear per page can be setup
* in /utils/siteConfig.js under `postsPerPage`.
*
*/

const plans = [
    {
        title: 'Data Diff',
        subTitle: 'Verify data changes across billions of rows',
        children: [
            {
                title: 'Max Dataset size',
                starer: '1M Rows',
                business: 'Unlimited',
                enterprise: 'Unlimited',
            },
            {
                title: 'Sampling',
                starer: '',
                business: 'checkmark',
                enterprise: 'checkmark',
            },
            {
                title: 'Cross-database diff',
                starer: '',
                business: '',
                enterprise: 'checkmark',
            },
            {
                title: 'Github integration',
                starer: '',
                business: '',
                enterprise: 'checkmark',
            },
            {
                title: 'API',
                starer: '',
                business: '',
                enterprise: 'checkmark',
            },
        ],
    },
    {
        title: 'Catalog',
        subTitle: 'Lorem ipsum decription',
        children: [
            {
                title: 'Table Catalog',
                starer: 'checkmark',
                business: 'checkmark',
                enterprise: 'checkmark',
            },
            {
                title: 'Column Profiles',
                starer: 'checkmark',
                business: 'checkmark',
                enterprise: 'checkmark',
            },
            {
                title: 'Automatic Refresh',
                starer: '',
                business: 'checkmark',
                enterprise: 'checkmark',
            },
        ],
    },
    {
        title: 'Alerts',
        subTitle: 'Turn any SQL query into a smart alert in one click',
        children: [
            {
                title: 'Metric Monitoring',
                starer: 'checkmark',
                business: 'checkmark',
                enterprise: 'checkmark',
            },
            {
                title: 'Alert Escalation',
                starer: 'Email',
                business: React.createElement('div', { className: 'many-items' }, <>Email<br/>Slack</>),
                enterprise: React.createElement('div', { className: 'many-items' }, <>Email<br/>Slack<br/>PagerDuty<br/>Webhook</>),
            },
            {
                title: '# of metrics',
                starer: '5',
                business: '25',
                enterprise: 'Unlimited',
            },
        ],
    },
    {
        title: 'Support',
        subTitle: 'Lorem ipsum  about what support means for Datafold',
        children: [
            {
                title: 'Live in-product chat',
                starer: '',
                business: 'checkmark',
                enterprise: 'checkmark',
            },
            {
                title: 'Dedicated Onboarding',
                starer: '',
                business: '',
                enterprise: 'checkmark',
            },
        ],
    },
    {
        title: 'Security',
        subTitle: 'Turn any SQL query into a smart alert in one click',
        children: [
            {
                title: 'On-premise installation',
                starer: '',
                business: '',
                enterprise: React.createElement('div', { className: 'many-items' }, <>AWS<br/>GCP<br/>Data Center</>),
            },
            {
                title: 'SSO',
                starer: '',
                business: React.createElement('div', { className: 'many-items' }, <>GSuite<br/>Okta</>),
                enterprise: React.createElement('div', { className: 'many-items' }, <>GSuite<br/>Okta<br/>SAML<br/>LDAP</>),
            },
        ],
    },
]

const ContextAwareToggle = ({ children, eventKey, callback }) => {
    const currentEventKey = useContext(AccordionContext)

    const decoratedOnClick = useAccordionToggle(
        eventKey,
        () => callback && callback(eventKey),
    )

    const isCurrentEventKey = currentEventKey === eventKey

    return (
        <Button
            variant="link"
            style={{ transform: isCurrentEventKey ? 'matrix(0.71, -0.71, 0.71, 0.71, 0, 0)' : '' }}
            onClick={decoratedOnClick}
        >
            {children}
        </Button>
    )
}
const Pricing = ({ data, location }) => {
    // const [yearly, setYearly] = useState(true)
    const [faqList, setFaqList] = useState([])

    useEffect(() => {
        const fetchTestimonials = async () => {
            const { faqs } = await request(
                graphCMSUrl,
                `
                {
                      faqs(stage: PUBLISHED) {
                        answer
                        question
                      }
                }
                `
            )
            setFaqList(faqs)
        }

        fetchTestimonials()
    }, [])

    /* const handleChangePrice = (e) => {
        setYearly(!e.currentTarget.checked)
    }*/

    return (
        <>
            <MetaData
                data={data}
                location={location}
                type="website"
            />
            <Layout footerClass="large">
                <section className="prices">
                    <Container>
                        <Row style={{ alignItems: 'center' }} className="observability-data">
                            <Col className="price-container">
                                {/*<span className="sub-title">The Features</span>*/}
                                <h2>
                                    Pricing
                                </h2>
                                <p className="general-content">
                                    Every Data professional deserves the best tools. Our pricing model accommodates teams and infrastructure of any size.
                                </p>
                                <div className="pricing-table">
                                    <Container>
                                        <Row className="plan">
                                            <Col lg={3}></Col>
                                            <Col lg={3} md={6} className="mobile-block">
                                                <span className="title">Community</span>
                                                <div className="price">Free</div>
                                                <ButtonAnalytics
                                                    href="https://app.datafold.com/org-signup"
                                                    target="_blank"
                                                    variant="outline-primary"
                                                    size="lg"
                                                    action_name="Get started(pricing)"
                                                >
                                                    Get started
                                                </ButtonAnalytics>
                                            </Col>
                                            <Col lg={3} md={6} className="mobile-block">
                                                <span className="title">Business</span>
                                                <div className="price">Custom</div>
                                                <ButtonAnalytics
                                                    href="https://app.datafold.com/org-signup"
                                                    target="_blank"
                                                    variant="outline-primary"
                                                    size="lg"
                                                    action_name="Get started(pricing)"
                                                >
                                                    Get started
                                                </ButtonAnalytics>
                                            </Col>
                                            <Col lg={3} md={6} className="mobile-block">
                                                <span className="title">Enterprise</span>
                                                <div className="price">Custom</div>
                                                <ButtonAnalytics
                                                    schedule="true"
                                                    action_name="Schedule Demo(Pricing)"
                                                    variant="outline-primary"
                                                    size="lg"
                                                >
                                                    Schedule Demo
                                                </ButtonAnalytics>
                                            </Col>
                                        </Row>
                                        {plans.map((obj, index) => {
                                            const totalItems = obj.children.length - 1
                                            return (<React.Fragment key={index}>
                                                <Row className="section-title">
                                                    <Col>
                                                        {obj.title}
                                                        <div className="mobile-sub-title">{obj.subTitle}</div>
                                                    </Col>
                                                </Row>
                                                {obj.children.map((obj, childIndex) => (
                                                    <Row className={`section-row ${totalItems !== childIndex ? 'border-line' : '' }`} key={childIndex}>
                                                        <Col lg={3} className="first-col" >{obj.title}</Col>
                                                        <Col lg={3} xs={4} className="next-col">
                                                            <div className="mobile-col-sub-title">Community</div>
                                                            {obj.starer === 'checkmark' ? <CheckmarkImage/> : obj.starer}
                                                        </Col>
                                                        <Col lg={3} xs={4} className="next-col">
                                                            <div className="mobile-col-sub-title">Business</div>
                                                            {obj.business === 'checkmark' ? <CheckmarkImage/> : obj.business}
                                                        </Col>
                                                        <Col lg={3} xs={4} className="next-col">
                                                            <div className="mobile-col-sub-title">Enterprise</div>
                                                            {obj.enterprise === 'checkmark' ? <CheckmarkImage/> : obj.enterprise}
                                                        </Col>
                                                    </Row>
                                                ))}
                                            </React.Fragment>
                                            )
                                        })}
                                        <Row className="footer-buttons">
                                            <Col lg={3}></Col>
                                            <Col lg={3}>
                                                <ButtonAnalytics
                                                    href="https://app.datafold.com/org-signup"
                                                    target="_blank"
                                                    variant="primary"
                                                    size="lg"
                                                    action_name="Get started(pricing)"
                                                >
                                                    Get started
                                                </ButtonAnalytics>
                                            </Col>
                                            <Col lg={3}>
                                                <ButtonAnalytics
                                                    href="https://app.datafold.com/org-signup"
                                                    target="_blank"
                                                    variant="outline-primary"
                                                    size="lg"
                                                    action_name="Get started(pricing)"
                                                >
                                                    Get started
                                                </ButtonAnalytics>
                                            </Col>
                                            <Col lg={3}>
                                                <ButtonAnalytics
                                                    schedule="true"
                                                    action_name="Schedule Demo(Pricing)"
                                                    variant="outline-primary"
                                                    size="lg"
                                                >
                                                    Schedule Demo
                                                </ButtonAnalytics>
                                            </Col>
                                        </Row>
                                    </Container>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </section>
                {(faqList && faqList.length > 0) && (
                    <section className="knowledge-base" style={{ display: 'block' }}>
                        <Container>
                            <Row style={{ textAlign: 'center' }}>
                                <Col>
                                    <span className="sub-title">Knowledge Base</span>
                                    <h2>
                                    Frequently asked questions
                                    </h2>
                                    <Accordion defaultActiveKey="0">
                                        {faqList.map((obj, index) => (
                                            <Card key={index}>
                                                <Card.Header>
                                                    <span>{obj.question}</span>
                                                    <ContextAwareToggle eventKey={index + 1}>+</ContextAwareToggle>
                                                </Card.Header>
                                                <Accordion.Collapse eventKey={index + 1}>
                                                    <Card.Body ><div dangerouslySetInnerHTML={{ __html: obj.answer }}></div></Card.Body>
                                                </Accordion.Collapse>
                                            </Card>
                                        ))}

                                    </Accordion>
                                </Col>
                            </Row>
                        </Container>
                    </section>
                )}
                <ActNow/>
            </Layout>
        </>
    )
}
ContextAwareToggle.propTypes = {
    eventKey: PropTypes.number,
    callback: PropTypes.func,
}

Pricing.propTypes = {
    data: PropTypes.shape({
        ghostPage: PropTypes.object.isRequired,
    }).isRequired,
    location: PropTypes.shape({
        pathname: PropTypes.string.isRequired,
    }).isRequired,
    pageContext: PropTypes.object,
}

export default Pricing

// This page query loads all posts sorted descending by published date
// The `limit` and `skip` values are used for pagination
export const pageQuery = graphql`
  query PricingQuery($slug: String!) {
        ghostPage(slug: { eq: $slug }) {
            ...GhostPageFields
        }
    }
`
